import React, { useEffect } from "react";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import AppRoutes from "./routes";
import useAuthenticated from "./utils/useAuthenticated";

import { Toaster } from 'react-hot-toast';

import "./App.scss";
import 'react-loading-skeleton/dist/skeleton.css'
import "rc-tree/assets/index.css";

function RedirectOnAuth() {
  const allowedUnauthenticatedPathNames = ["/signup"];
  const navigate = useNavigate();
  const isAuthenticated = useAuthenticated();

  useEffect(() => {
    if (
      !isAuthenticated &&
      !allowedUnauthenticatedPathNames.includes(window.location.pathname)
    )
      navigate("/login");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, navigate]);

  return null;
}

function App() {
  return (
    <Router>
      <RedirectOnAuth />
      <AppRoutes />
      <Toaster position="top-center"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          // Define default options
          duration: 5000,
          removeDelay: 1000,

          // Default options for specific types
          success: {
            duration: 3000,
          },
        }} 
      />
    </Router>
  );
}

export default App;
